(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/date-time-picker.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/date-time-picker.js');
"use strict";


const _svs$ui$reactFormInpu = svs.ui.reactFormInputs,
  DateInput = _svs$ui$reactFormInpu.DateInput,
  TimeInput = _svs$ui$reactFormInpu.TimeInput;
const _svs$tickets_giftshop = svs.tickets_giftshop.constants.names,
  DATE = _svs$tickets_giftshop.DATE,
  TIME = _svs$tickets_giftshop.TIME;
const DATE_AND_TIME = svs.tickets_giftshop.constants.dateSelectorKey.DATE_AND_TIME;
const DateTimePicker = _ref => {
  let date = _ref.date,
    time = _ref.time,
    _ref$isHidden = _ref.isHidden,
    isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
    onInputChange = _ref.onInputChange,
    _ref$minDate = _ref.minDate,
    minDate = _ref$minDate === void 0 ? svs.utils.date.SimpleDate(new Date()) : _ref$minDate,
    _ref$maxDate = _ref.maxDate,
    maxDate = _ref$maxDate === void 0 ? svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))) : _ref$maxDate;
  const handleDateChange = e => {
    onInputChange({
      target: {
        value: {
          date: e.target.value,
          dateSelectorUsed: DATE_AND_TIME
        },
        name: DATE
      }
    });
  };
  const handleTimeChange = e => {
    onInputChange({
      target: {
        value: {
          time: e.target.value,
          dateSelectorUsed: DATE_AND_TIME
        },
        name: TIME
      }
    });
  };
  return React.createElement("div", {
    className: "g-date-input gutter-sm-2 ".concat(isHidden ? 'tg-date-time-hidden' : '')
  }, React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-sm-6 col-xs-12"
  }, React.createElement(DateInput, {
    max: maxDate,
    min: minDate,
    name: DATE,
    onChange: handleDateChange,
    value: date
  })), React.createElement("div", {
    className: "col-sm-6 col-xs-12"
  }, React.createElement(TimeInput, {
    name: TIME,
    onChange: handleTimeChange,
    value: time
  }))));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.DateTimePicker = DateTimePicker;

 })(window);